import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonStyled } from './styles';

class Button extends Component {
  static propTypes = {
    text: PropTypes.string,
    onClick: PropTypes.func,
    type: PropTypes.string,
    width: PropTypes.string,
    float: PropTypes.string
  }
  static defaultProps = {
    text: '',
    onClick: () => { },
    type: '',
    width: 'auto',
    float: 'left'
  }

  render() {
    const { text, onClick, type, width, float } = this.props;
    return (
      <ButtonStyled type={type} onClick={onClick} width={width} float={float}>
        {text}
      </ButtonStyled>
    )
  }
}

export default Button;



/** WEBPACK FOOTER **
 ** ./src/components/Button/index.js
 **/